<template>
	<nut-navbar class="navbar" :left-show="false" title="个人中心"></nut-navbar>
	<div class="container">
		<div class="userinfo">
			<nut-avatar
				shape="square"
				size="large"
				:icon="
					user && user.icon
						? user.icon
						: 'https://ddp-common.oss-cn-hangzhou.aliyuncs.com/public/app/assets/del_img/user_icon.jpg'
				"
			></nut-avatar>
			<div class="info">
				<div class="info-container">
					<div class="username">{{ user && user.name }}</div>
					<div class="userphone">{{ user && user.phone }}</div>
				</div>
				<span
					class="btn-register"					
					v-if="handleMenuVisible('register')"
					@click="handleRegister"
				>
					注册
				</span>
			</div>
		</div>
		<nut-cell-group round-radius="0">
			<nut-cell
				title="用户信息"
				@click="$router.push('/userinfo')"
				v-if="handleMenuVisible('user')"
			>
				<template #icon>
					<nut-icon
						class-prefix="icon"
						font-class-name="iconfont"
						name="user"
						color="#61c2d3"
						class="icon"
					>
					</nut-icon>
				</template>
			</nut-cell>
			<nut-cell
				title="修改密码"
				@click="visible = true"
				v-if="handleMenuVisible('password')"
			>
				<template #icon>
					<nut-icon
						class-prefix="icon"
						font-class-name="iconfont"
						name="unlock"
						color="#e8a644"
						class="icon"
					>
					</nut-icon>
				</template>
			</nut-cell>
			<nut-cell
				title="绑定微信"
				@click="$router.push('/wxbind')"
				v-if="handleMenuVisible('wxbind')"
			>
				<template #icon>
					<nut-icon
						class-prefix="icon"
						font-class-name="iconfont"
						name="weixin"
						color="#5fc057"
						class="icon"
					>
					</nut-icon>
				</template>
			</nut-cell>
		</nut-cell-group>
		<nut-cell
			style="margin: 10px 0"
			round-radius="0"
			title="激活设备"
			@click="$router.push('/activation')"
			v-if="handleMenuVisible('activation')"
		>
			<template #icon>
				<nut-icon
					class-prefix="icon"
					font-class-name="iconfont"
					name="plus-circle"
					color="#6ec049"
					class="icon"
				>
				</nut-icon>
			</template>
		</nut-cell>
		<nut-cell-group>
			<nut-cell
				title="账单发票"
				@click="$router.push('/bill')"
				v-if="handleMenuVisible('invoice')"
			>
				<template #icon>
					<nut-icon
						class-prefix="icon"
						font-class-name="iconfont"
						name="detail"
						color="#4c87ed"
						class="icon"
					>
					</nut-icon>
				</template>
			</nut-cell>
			<nut-cell
				title="使用说明"
				@click="$router.push('/howtouse')"
				v-if="handleMenuVisible('help')"
			>
				<template #icon>
					<nut-icon
						class-prefix="icon"
						font-class-name="iconfont"
						name="question-circle"
						color="#4c87ed"
						class="icon"
					>
					</nut-icon>
				</template>
			</nut-cell>
			<nut-cell
				title="意见反馈"
				@click="$router.push('/feedback')"
				v-if="handleMenuVisible('feedback')"
			>
				<template #icon>
					<nut-icon
						class-prefix="icon"
						font-class-name="iconfont"
						name="warning-circle"
						color="#faad14"
						class="icon"
					>
					</nut-icon>
				</template>
			</nut-cell>
		</nut-cell-group>
		<nut-cell
			round-radius="0"
			style="text-align: center"
			title="退出登录"
			@click="handleLogout"
		></nut-cell>
	</div>

	<edit-password-modal v-model="visible" />
</template>

<script>
import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';
import EditPasswordModal from './components/editPassword.vue';
import { userApi } from '@/apis';
import useNavigate from '@/hooks/useNavigate';

export default {
	name: 'UserCenter',
	components: {
		EditPasswordModal,
	},
	setup() {
		const store = useStore();
		const { push } = useNavigate();
		const visible = ref(false);
		const user = ref(null);

		const handleLogout = () => {
			store.dispatch('user/logout');
		};

		const handleRegister = () => {
			push('/register');
		};

		const handleMenuVisible = (type) => {
			return (
				Array.isArray(user.value?.menu) &&
				user.value.menu.includes(type)
			);
		};

		onMounted(async () => {
			const res = await userApi.getUser();
			user.value = res;
		});

		return {
			visible,
			user,
			handleRegister,
			handleLogout,
			handleMenuVisible,
		};
	},
};
</script>

<style lang="scss" scoped>
.container {
	height: calc(100vh - $tabbar-height - $navbar-height);
	background: $bg_color;
}

.userinfo {
	background: #fff;
	display: flex;
	align-items: center;
	padding: 10px 16px;

	.info {
		flex: 1;
		@include flex-center;
		margin-left: 10px;
		&-container {
			flex: 1;
		}
		.btn-register {
			padding: 4px;
			font-size: 12px;
			color: #0096ff;
		}
	}

	.username {
		margin-bottom: 8px;
		line-height: 18px;
		font-size: 14px;
		font-weight: 500;
	}

	.userphone {
		color: #999;
		font-size: 13px;
		line-height: 1.2;
	}
}

.icon {
	font-size: $large-font-size;
	margin-right: 4px;
}
</style>
